import TasksTabs from "../_TasksTabs";
import AppLayout from "@/layouts/AppLayout";
import { DOMAIN, PERMISSION, useRequireCapability } from "@/hooks/useCapabilities";
import usePageTitle from "@/hooks/usePageTitle";

export default function TasksLayout() {
  useRequireCapability({
    domain: DOMAIN.TASKS,
    permission: PERMISSION.viewTasks
  });
  usePageTitle("/tasks", "Tasks");

  return (
    <AppLayout bottomBar>
      <TasksTabs />
    </AppLayout>
  );
}
